import { type TStructuredCrossLinkTag } from '@core/api'

import { type TCrossLinkTag } from '@core/models'

export const convertCrossLinkTag = (tag: string | TStructuredCrossLinkTag): TCrossLinkTag => {
    return typeof tag === 'string' ? { id: tag } : { id: tag.id }
}
